import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=0831cc1e&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=0831cc1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831cc1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0831cc1e')) {
      api.createRecord('0831cc1e', component.options)
    } else {
      api.reload('0831cc1e', component.options)
    }
    module.hot.accept("./AuthLayout.vue?vue&type=template&id=0831cc1e&scoped=true", function () {
      api.rerender('0831cc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/AuthLayout.vue"
export default component.exports